module.exports = __webpack_public_path__ + "static/media/1_r_spiral_63.02_81.57.229b54c2.png";